import Vue from 'vue';
import Vuex from 'vuex';
import state from './state';
import getters from './getters';
import actions from './actions';
import mutations from './mutations';
// import axios from 'axios';
// import router from '../router';
import createPersistedState from 'vuex-persistedstate';

Vue.use(Vuex);

// export const createStore = () => {
//   const store = new Vuex.Store({
//     state: {
//     },
//     getters: {
//     },
//     mutations: {
//     },
//     actions: {
//     },
//     modules: {
//     },
//   });

//   return store;
// };

export default new Vuex.Store({
  // state: {
  // },
  // getters: {
  // },
  // actions: {
  // },
  // mutations: {
  // },
  state,
  getters,
  actions,
  mutations,
  modules: {
  },
  plugins: [createPersistedState({
    reducer: state => ({
      auth_data: state.auth_data,
      auth_token: state.auth_token,
      // filter size global
      record_size: state.record_size,
      // filter date global
      from_date: state.from_date,
      end_date: state.end_date,

      // filter date per menu
      from_date_recent_location: state.from_date_recent_location,
      end_date_recent_location: state.end_date_recent_location,

      from_date_application_usage: state.from_date_application_usage,
      end_date_application_usage: state.end_date_application_usage,

      from_date_history_location: state.from_date_history_location,
      end_date_history_location: state.end_date_history_location,

      from_date_history_browsing: state.from_date_history_browsing,
      end_date_history_browsing: state.end_date_history_browsing,

      from_date_device_history: state.from_date_device_history,
      end_date_device_history: state.end_date_device_history,

      from_date_tethered_devices: state.from_date_tethered_devices,
      end_date_tethered_devices: state.end_date_tethered_devices,

      from_date_possible_location: state.from_date_possible_location,
      end_date_possible_location: state.end_date_possible_location,

      from_date_aerial_log: state.from_date_aerial_log,
      end_date_aerial_log: state.end_date_aerial_log,

      from_date_signal_status: state.from_date_signal_status,
      end_date_signal_status: state.end_date_signal_status,

      fcm_token: state.fcm_token,
      notification_count: state.notification_count,

      download_app: state.download_app,
    }),
  })],
});
